import React, { useRef, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import constantsDesign from '../../../utils/constants';
import serviceOrders from "../../../services/orders";
import AuthService from "../../../services/security/auth.service";
import emailService from "../../../services/sendEmail";
import { ThemeProvider } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import MenuApp from '../../../components/Menu';
import logoTest from '../../../img/web_media_banner.png'
import TypographyComponent from '../../../components/Typography';
import PercentageComponente from '../../../components/Percentage';
import TextFieldComponent from '../../../components/TextField';
import LabelIcon from '@mui/icons-material/Label';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';

import SelectComponent from '../../../components/Select';
import FileComponent from '../../../components/File';
import JsonComponent from '../../../components/Json';
import NumberComponent from '../../../components/Number';
import CurrencyComponent from '../../../components/Currency';
import CheckBoxComponent from '../../../components/CheckBox';
import SwitchComponent from '../../../components/Switch';
import DateComponent from '../../../components/Date';
import RadioComponent from '../../../components/Radio';
import dataSource from "../../../components/Select/dataSource";

import initialValues from '../../../utils/initialValues';
import whereFunctions from '../../../utils/whereFunctions';
import initialGroupSubGroup from '../../../utils/initialGroupSubGroup';
import setDefaultValue from '../../../utils/setDefaultValue';

const SystemPages = () => {
    const [entity, setEntity] = useState([]);
    const [field, setField] = useState({});
    const [data] = useState([]);
    const [info, setInfo] = useState([]);
    const [group, setGroup] = useState([]);
    const [groupRequirements, setGroupRequirements] = useState([{
        index: 0
    }]);
    const [load, setLoad] = useState(true);
    const [revision, setRevision] = useState(false);

    const [error, setError] = useState('');
    const [order, setOrder] = useState(null);
    const [optionsOrder, setOptionsOrder] = useState([]);
    const boxRef = useRef(null);
    const location = useLocation();
    let navigate = useNavigate();
    const params = new URLSearchParams(location.search)
    let id = params.get("id");
    const user = AuthService.getCurrentUser();

    useEffect(() => {
        setLoad(true);
        serviceOrders.getOrderId(user.client, user.data.instance, id).then((response) => {

            const fetchData = async (arrayFlag) => {
                let info = await dataSource(arrayFlag, user.data.instance, setInfo);
                setDefaultValue(arrayFlag, info, setField);
                initialGroupSubGroup(arrayFlag, setField, info, setGroup);
                //setInfo(info);

                console.log('order-> ' + JSON.stringify(response.data))
                setOrder(response.data);
                searchOrder(response.data, info);
                setLoad(false);
            };
            setGroup(initialValues.initialArrayGroup(response.data.order));
            setField(initialValues.initialField(response.data.order));
            fetchData(response.data.order);
            let arrayOrderOptions = [];
            for (let i = 0; i < response.data.order.length; i++) {
                arrayOrderOptions.push({
                    id: response.data.order[i].id,
                    label: `${response.data.order[i].id}_${response.data.order[i].name}`
                })
            }
            setOptionsOrder(arrayOrderOptions);

        }).catch((error) => {
            setLoad(false);
            console.log(error);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const rechazar = () => {
        setRevision(false);
        //Actualizar status a Rechazado en la colección firestore
        for (let u = 0; u < order.order.length; u++) {
            for (let y = 0; y < order.order[u].boxes.length; y++) {
                for (let d = 0; d < order.order[u].boxes[y].fields.length; d++) {
                    if (order.order[u].boxes[y].fields[d].idFieldTable === 'status') {
                        order.order[u].boxes[y].fields[d].value = 'Rechazado';
                    }
                }
            }
        }
        serviceOrders.save(user.client, user.data.instance, id, order).then(() => {
            navigate(`/listrequirements`);
            window.location.reload();
        }).catch((error) => {
            console.log(error);
        });
    }

    const aprobar = () => {

        const inputElement = document.getElementById('nrocuenta');
        const nroCuenta = inputElement.value;
        console.log('nroCuenta ' + nroCuenta)
        setError('');
        if (!nroCuenta) {
            console.log('INGRESA A ERROR')
            setError('Complete Número de cuenta');
        }
        else {
            setRevision(false);
            for (let u = 0; u < order.order.length; u++) {
                for (let y = 0; y < order.order[u].boxes.length; y++) {
                    for (let d = 0; d < order.order[u].boxes[y].fields.length; d++) {
                        if (order.order[u].boxes[y].fields[d].idFieldTable === 'status') {
                            order.order[u].boxes[y].fields[d].value = 'Aprobado';
                        }
                        if (order.order[u].boxes[y].fields[d].idFieldTable === 'tradeAccountId') {
                            order.order[u].boxes[y].fields[d].value = nroCuenta;
                        }
                    }
                }
            }

            //Actualiza en firestore APROBADO
            serviceOrders.save(user.client, user.data.instance, id, order).then(() => {

                //INSERTA REGISTROS A MYSQL
                let arrayRequestFinal = [];
                //TRADE ACCOUNT
                let tablesTradeAccount = [];
                let fieldsTradeAccount = [];
                let table = '';
                order.order.forEach((itemOrder) => {
                    itemOrder.boxes.forEach((itemBoxs) => {
                        itemBoxs.fields.forEach((item) => {
                            if (item.table === 'tradeAccount') {
                                table = `${user.data.instance}.${item.table}`
                                if (item.table !== null) {
                                    if (item.value !== null && item.value !== 'index') {
                                        let value = item.value;
                                        if (value === true || value === 'true') {
                                            value = '1'
                                        }
                                        if (value === false || value === 'false') {
                                            value = '0'
                                        }
                                        fieldsTradeAccount.push({ id: item.idFieldTable, value: `'${value}'` })
                                    }
                                }
                            }
                        })
                    })
                })
                fieldsTradeAccount.push({ id: 'id', value: nroCuenta })

                tablesTradeAccount.push({
                    table: table,
                    fields: fieldsTradeAccount
                })
                arrayRequestFinal.push({
                    idDocSave: {
                        id: 1,
                        tables: tablesTradeAccount
                    }
                })

                //ENTITY - ARG ENTITY - ENTITY PROPERTY, ENTITY REL, ADDRESS BOOK
                let tablesFields = [];
                order.order.forEach((itemOrder) => {
                    if ((itemOrder.id === '1' || itemOrder.id === '2') && itemOrder.entityDocId === '2') {
                        itemOrder.boxes.forEach((itemBoxs) => {
                            itemBoxs.fields.forEach((item) => {
                                if (item.group === null) {
                                    table = item.table;
                                    if (item.table !== null && item.table !== 'tradeAccount') {
                                        let existe = false;
                                        table = `${user.data.instance}.${item.table}`;
                                        if (item.value !== null && item.value !== 'index') {
                                            let value = item.value;
                                            if (value === true || value === 'true') {
                                                value = '1'
                                            }
                                            if (value === false || value === 'false') {
                                                value = '0'
                                            }
                                            for (let f = 0; f < tablesFields.length; f++) {
                                                if (tablesFields[f].table === table) {
                                                    existe = true;
                                                    tablesFields[f].fields.push({ id: item.idFieldTable, value: `'${value}'` })
                                                }
                                            }
                                            if (existe === false) {
                                                tablesFields.push({
                                                    table: table,
                                                    fields: [{ id: item.idFieldTable, value: `'${value}'` }]
                                                })
                                            }
                                        }
                                    }
                                } else {
                                    item.group.forEach((itemgroup) => {
                                        let table;
                                        let addGroupSave = false;
                                        let fields = [];
                                        itemgroup.fields.forEach((itemfieldsgroup, index) => {
                                            if (itemfieldsgroup.table !== null) {
                                                if (index === 0) {
                                                    table = `${user.data.instance}.${itemfieldsgroup.table}`;
                                                }

                                                let value = itemfieldsgroup.value;
                                                if (value !== null) {
                                                    if (value === true || value === 'true') {
                                                        value = '1'
                                                    }
                                                    if (value === false || value === 'false') {
                                                        value = '0'
                                                    }
                                                    fields.push({
                                                        id: itemfieldsgroup.idFieldTable, value: `'${value}'`
                                                    })
                                                    if (itemfieldsgroup.idFieldTable !== 'id' &&
                                                        itemfieldsgroup.idFieldTable !== 'addressTypeId' &&
                                                        itemfieldsgroup.idFieldTable !== 'isInactive' &&
                                                        itemfieldsgroup.idFieldTable !== 'isDefault' &&
                                                        itemfieldsgroup.idFieldTable !== 'entityTypeId' &&
                                                        itemfieldsgroup.idFieldTable !== 'maritalStatusId' &&
                                                        itemfieldsgroup.idFieldTable !== 'entityRelTypeId' &&
                                                        value !== '0' && value !== '') {
                                                        addGroupSave = true;
                                                    }
                                                }
                                            }
                                        })
                                        if (table && addGroupSave) {
                                            tablesFields.push({
                                                table: table,
                                                fields: fields
                                            })
                                        }
                                    })
                                }
                            })
                        })
                        arrayRequestFinal.push({
                            idDocSave: {
                                id: 2,
                                tables: tablesFields
                            }
                        })
                    }
                });


                tablesFields = [];
                order.order.forEach((itemOrder) => {
                    if ((itemOrder.id !== '2') && itemOrder.entityDocId === '2') {
                        itemOrder.boxes.forEach((itemBoxs) => {
                            itemBoxs.fields.forEach((item) => {
                                if (item.group === null) {
                                    table = item.table;
                                    if (item.table !== null && item.table !== 'tradeAccount') {
                                        let existe = false;
                                        table = `${user.data.instance}.${item.table}`;
                                        if (item.value !== null && item.value !== 'index') {
                                            let value = item.value;
                                            if (value === true || value === 'true') {
                                                value = '1'
                                            }
                                            if (value === false || value === 'false') {
                                                value = '0'
                                            }
                                            for (let f = 0; f < tablesFields.length; f++) {
                                                if (tablesFields[f].table === table) {
                                                    existe = true;
                                                    tablesFields[f].fields.push({ id: item.idFieldTable, value: `'${value}'` })
                                                }
                                            }
                                            if (existe === false) {
                                                tablesFields.push({
                                                    table: table,
                                                    fields: [{ id: item.idFieldTable, value: `'${value}'` }]
                                                })
                                            }
                                        }
                                    }
                                } else {
                                    item.group.forEach((itemgroup) => {
                                        let table;
                                        let addGroupSave = false;
                                        let fields = [];
                                        itemgroup.fields.forEach((itemfieldsgroup, index) => {
                                            if (itemfieldsgroup.table !== null) {
                                                if (index === 0) {
                                                    table = `${user.data.instance}.${itemfieldsgroup.table}`;
                                                }

                                                let value = itemfieldsgroup.value;
                                                if (value !== null) {
                                                    if (value === true || value === 'true') {
                                                        value = '1'
                                                    }
                                                    if (value === false || value === 'false') {
                                                        value = '0'
                                                    }
                                                    fields.push({
                                                        id: itemfieldsgroup.idFieldTable, value: `'${value}'`
                                                    })
                                                    if (itemfieldsgroup.idFieldTable !== 'id' &&
                                                        itemfieldsgroup.idFieldTable !== 'addressTypeId' &&
                                                        itemfieldsgroup.idFieldTable !== 'isInactive' &&
                                                        itemfieldsgroup.idFieldTable !== 'isDefault' &&
                                                        itemfieldsgroup.idFieldTable !== 'entityTypeId' &&
                                                        itemfieldsgroup.idFieldTable !== 'maritalStatusId' &&
                                                        itemfieldsgroup.idFieldTable !== 'entityRelTypeId' &&
                                                        value !== '0' && value !== '') {
                                                        addGroupSave = true;
                                                    }
                                                }
                                            }
                                        })
                                        if (table && addGroupSave) {
                                            tablesFields.push({
                                                table: table,
                                                fields: fields
                                            })
                                        }
                                    })
                                }
                            })
                        })
                        arrayRequestFinal.push({
                            idDocSave: {
                                id: Number(itemOrder.id),
                                tables: tablesFields
                            }
                        })
                    }
                });

                order.order.forEach((itemOrder) => {
                    if (Number(itemOrder.entityDocId) > 2) {
                        console.log('itemOrder.entityDocId-> ' + itemOrder.entityDocId)
                        let fullName = null;
                        itemOrder.boxes.forEach((itemBoxs) => {
                            itemBoxs.fields.forEach((item) => {
                                if (item.idFieldTable === 'fullName' && item.value) {
                                    fullName = `'${item.value}'`;
                                }
                            })
                        })
                        console.log('fullName-> ' + fullName)
                        if (fullName) {
                            let indexCollection;
                            for (let l = 0; l < arrayRequestFinal.length; l++) {
                                for (let d = 0; d < arrayRequestFinal[l].idDocSave.tables.length; d++) {
                                    for (let e = 0; e < arrayRequestFinal[l].idDocSave.tables[d].fields.length; e++) {
                                        if (arrayRequestFinal[l].idDocSave.tables[d].fields[e].id === 'fullName' && arrayRequestFinal[l].idDocSave.tables[d].fields[e].value === fullName) {
                                            indexCollection = l;
                                        }
                                    }
                                }
                            }
                            console.log('indexCollection-> ' + indexCollection)

                            itemOrder.boxes.forEach((itemBoxs) => {
                                itemBoxs.fields.forEach((item) => {
                                    if (item.group === null) {
                                        table = item.table;
                                        if (item.table !== null && item.table !== 'tradeAccount') {
                                            let existe = false;
                                            table = `${user.data.instance}.${item.table}`;
                                            if (item.value !== null && item.value !== 'index') {
                                                let value = item.value;
                                                if (value === true || value === 'true') {
                                                    value = '1'
                                                }
                                                if (value === false || value === 'false') {
                                                    value = '0'
                                                }
                                                for (let f = 0; f < arrayRequestFinal[indexCollection].idDocSave.tables.length; f++) {

                                                    if (arrayRequestFinal[indexCollection].idDocSave.tables[f].table === table &&
                                                        arrayRequestFinal[indexCollection].idDocSave.tables[f].entityDocId === undefined) {
                                                        existe = true;
                                                        arrayRequestFinal[indexCollection].idDocSave.tables[f].fields.push({ id: item.idFieldTable, value: `'${value}'` })
                                                    } else {
                                                        if (arrayRequestFinal[indexCollection].idDocSave.tables[f].entityDocId !== undefined &&
                                                            arrayRequestFinal[indexCollection].idDocSave.tables[f].table === table &&
                                                            Number(arrayRequestFinal[indexCollection].idDocSave.tables[f].entityDocId) === Number(itemOrder.entityDocId)
                                                        ) {
                                                            existe = true;
                                                            arrayRequestFinal[indexCollection].idDocSave.tables[f].fields.push({ id: item.idFieldTable, value: `'${value}'` })
                                                        }
                                                    }
                                                }

                                                if (existe === false) {
                                                    arrayRequestFinal[indexCollection].idDocSave.tables.push({
                                                        entityDocId: itemOrder.entityDocId,
                                                        isGroup: false,
                                                        table: table,
                                                        fields: [{ id: item.idFieldTable, value: `'${value}'` }]
                                                    })
                                                }
                                            }
                                        }
                                    } else {
                                        item.group.forEach((itemgroup) => {
                                            let table;
                                            let addGroupSave = false;
                                            let fields = [];
                                            itemgroup.fields.forEach((itemfieldsgroup, index) => {
                                                if (itemfieldsgroup.table !== null) {
                                                    if (index === 0) {
                                                        table = `${user.data.instance}.${itemfieldsgroup.table}`;
                                                    }

                                                    let value = itemfieldsgroup.value;
                                                    if (value !== null) {
                                                        if (value === true || value === 'true') {
                                                            value = '1'
                                                        }
                                                        if (value === false || value === 'false') {
                                                            value = '0'
                                                        }
                                                        fields.push({
                                                            id: itemfieldsgroup.idFieldTable, value: `'${value}'`
                                                        })
                                                        if (itemfieldsgroup.idFieldTable !== 'id' &&
                                                            itemfieldsgroup.idFieldTable !== 'addressTypeId' &&
                                                            itemfieldsgroup.idFieldTable !== 'isInactive' &&
                                                            itemfieldsgroup.idFieldTable !== 'isDefault' &&
                                                            itemfieldsgroup.idFieldTable !== 'entityTypeId' &&
                                                            itemfieldsgroup.idFieldTable !== 'maritalStatusId' &&
                                                            itemfieldsgroup.idFieldTable !== 'entityRelTypeId' &&
                                                            value !== '0' && value !== '') {
                                                            addGroupSave = true;
                                                        }
                                                    }
                                                }
                                            })
                                            if (table && addGroupSave) {
                                                arrayRequestFinal[indexCollection].idDocSave.tables.push({
                                                    entityDocId: itemOrder.entityDocId,
                                                    isGroup: true,
                                                    table: table,
                                                    fields: fields
                                                })
                                            }
                                        })
                                    }
                                })
                            })
                        }
                    }
                })

                for (let l = 0; l < arrayRequestFinal.length; l++) {

                    for (let a = 0; a < arrayRequestFinal[l].idDocSave.tables.length; a++) {

                        var fields = arrayRequestFinal[l].idDocSave.tables[a].fields;
                        var uniqueFields = [];
                        var uniqueIds = {};
                        for (var x = 0; x < fields.length; x++) {
                            var idf = fields[x].id;

                            if (!uniqueIds[idf]) {
                                let valueFlag = null;
                                uniqueIds[idf] = true;
                                for (var d = 0; d < fields.length; d++) {
                                    if (fields[d].id === idf && fields[d].value !== null && fields[d].value !== '') {
                                        valueFlag = fields[d];
                                    }
                                }
                                if (valueFlag !== null)
                                    uniqueFields.push(valueFlag);
                                else
                                    uniqueFields.push(fields[x]);
                            }
                        }
                        arrayRequestFinal[l].idDocSave.tables[a].fields = uniqueFields;
                    }
                }

                console.log('arrayRequestFinal->' + JSON.stringify(arrayRequestFinal))




                /*order.order.map((itemOrder) => {
                    let arrayRequest = [];
                    itemOrder.boxes.map((itemBoxs) => {
                        itemBoxs.fields.map((item) => {
                            if (item.group === null) {
                                let existe = false;
                                for (var r = 0; r < arrayRequest.length; r++) {
                                    if (arrayRequest[r].table === `${user.data.instance}.${item.table}` && arrayRequest[r].id === itemOrder.id) {
                                        if (item.table !== null) {
                                            if (item.value !== null && item.value !== 'index') {
                                                let value = item.value;
                                                if (value === true || value === 'true') {
                                                    value = '1'
                                                }
                                                if (value === false || value === 'false') {
                                                    value = '0'
                                                }
                                                arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${value}'` })
                                            }
                                        }
                                        existe = true;
                                    }
                                }
                                if (existe === false) {
                                    if (item.table !== null) {
                                        if (item.value !== null && item.value !== 'index') {
                                            let value = item.value;
                                            if (value === true || value === 'true') {
                                                value = '1'
                                            }
                                            if (value === false || value === 'false') {
                                                value = '0'
                                            }
                                            arrayRequest.push({
                                                id: itemOrder.id, entityDocId: itemOrder.entityDocId, table: `${user.data.instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${value}'` }]
                                            })
                                        }
                                    }

                                }
                            } else {

                                item.group.map((itemgroup) => {
                                    let table;
                                    let fields = [];
                                    itemgroup.fields.map((itemfieldsgroup, index) => {
                                        if (itemfieldsgroup.table !== null) {
                                            if (index === 0) {
                                                table = `${user.data.instance}.${itemfieldsgroup.table}`;
                                            }

                                            let value = itemfieldsgroup.value;
                                            if (value !== null) {
                                                if (value === true || value === 'true') {
                                                    value = '1'
                                                }
                                                if (value === false || value === 'false') {
                                                    value = '0'
                                                }
                                                fields.push({
                                                    id: itemfieldsgroup.idFieldTable, value: `'${value}'`
                                                })
                                            }
                                        }
                                    })
                                    if (table)
                                        arrayRequest.push({
                                            table: table, fields: fields, entityDocId: itemOrder.entityDocId
                                        })
                                })
                            }

                        })
                    })
                    arrayRequestFinal.push({
                        'order': arrayRequest
                    })
                })*/

                /*console.log('arrayRequestFinal-> ' + JSON.stringify(arrayRequestFinal))

                let arrayTablesFields = [];
                //let arrayFields = [];
                //let table = '';
                //tradeAccount
                for (let g = 0; g < arrayRequestFinal.length; g++) {
                    for (let t = 0; t < arrayRequestFinal[g].order.length; t++) {
                        let table = arrayRequestFinal[g].order[t].table.split('.')[1];
                        if (table === 'tradeAccount') {
                            table = arrayRequestFinal[g].order[t].table;
                            for (let v = 0; v < arrayRequestFinal[g].order[t].fields.length; v++) {
                                arrayFields.push({
                                    id: arrayRequestFinal[g].order[t].fields[v].id,
                                    value: arrayRequestFinal[g].order[t].fields[v].value
                                })
                            }
                        }
                    }
                }
                arrayFields.push({ id: 'id', value: nroCuenta })
                arrayTablesFields.push({
                    table: table,
                    fields: arrayFields
                })
                informationService.save(arrayTablesFields).then((response) => {//SAVE TRADE ACCOUNT

                    for (let d = 0; d < arrayRequestFinal.length; d++) {

                        let arraySave = arrayRequestFinal[d].order;

                        informationService.viewTables().then((responseTables) => {
                            for (let y = 0; y < arraySave.length; y++) {
                                for (let r = 0; r < responseTables.data.length; r++) {
                                    let tableFlag = arraySave[y].table.split('.');
                                    if (tableFlag[1] === responseTables.data[r].name) {
                                        arraySave[y].table = `wbSys.${tableFlag[1]}`
                                    }
                                }
                            }

                            for (let l = 0; l < arraySave.length; l++) {
                                var fields = arraySave[l].fields;
                                var uniqueFields = [];
                                var uniqueIds = {};
                                for (var x = 0; x < fields.length; x++) {
                                    var idf = fields[x].id;
                                    if (!uniqueIds[idf]) {
                                        uniqueIds[idf] = true;
                                        uniqueFields.push(fields[x]);
                                    }
                                }
                                arraySave[l].fields = uniqueFields;
                            }

                            console.log('arraySave d-> ' + d + ' -> ' + JSON.stringify(arraySave))

                            informationService.save(arraySave).then((response) => {
        
                            }).catch((error) => {
                                console.log(error)
                            });

                        }).catch((error) => {
                            console.log(error)
                        });

                    }

                }).catch((error) => {
                    console.log(error)
                });*/
            }).catch((error) => {
                console.log(error)
            });


            //Envío de email
            /*let email;
            for (let u = 0; u < order.order.length; u++) {
                if (Number(order.order[u].id) === 1) {
                    for (let y = 0; y < order.order[u].boxes.length; y++) {
                        for (let d = 0; d < order.order[u].boxes[y].fields.length; d++) {
                            if (order.order[u].boxes[y].fields[d].table === 'entity' && order.order[u].boxes[y].fields[d].idFieldTable === 'email') {
                                email = order.order[u].boxes[y].fields[d].value;
                            }
                        }
                    }
                }
            }
            let mail = {
                recipient: email,
                msgBody: 'Solicitud Procesada \n Winvest APP',
                subject: `Su solicitud ha sido aprobada: ${order.id}`
            }
            emailService.sendEmail(mail).then(() => {
                //navigate(`/listrequirements`);
                //window.location.reload();
            }).catch((error) => {
                console.log(error);
            });*/
        }
    }

    const solicitarRevision = () => {
        setError('');
        console.log('solicitarRevision')
        setRevision(true);

    }

    const enviarRevisón = () => {
        setError('');
        let arrayRequerimiento = [];
        let validateRequerimiento = true;
        for (let r = 0; r < groupRequirements.length; r++) {
            const requerimientoElement = document.getElementById(`requerimiento_${groupRequirements[r].index}`);
            const descripcionElement = document.getElementById(`descripcion_${groupRequirements[r].index}`);

            if (!requerimientoElement.value || !descripcionElement.value)
                validateRequerimiento = false;

            if (r === 0) {
                arrayRequerimiento.push({
                    requirement: requerimientoElement.value,
                    description: [descripcionElement.value]
                })
            } else {
                let existe = false;
                for (let d = 0; d < arrayRequerimiento.length; d++) {
                    if (arrayRequerimiento[d].requirement === requerimientoElement.value) {
                        arrayRequerimiento[d].description.push(descripcionElement.value)
                        existe = true;
                    }
                }
                if (existe === false) {
                    arrayRequerimiento.push({
                        requirement: requerimientoElement.value,
                        description: [descripcionElement.value]
                    })
                }
            }
        }


        console.log('validateRequerimiento-> ' + validateRequerimiento)
        if (!validateRequerimiento)
            setError('Complete los campos de requerimientos y descripciones');
        else {

            const inputElement = document.getElementById('email');
            const body = inputElement.value;
            console.log('arrayRequerimiento-> ' + JSON.stringify(arrayRequerimiento))
            if (body) {
                let email;
                for (let u = 0; u < order.order.length; u++) {
                    if (Number(order.order[u].id) === 1) {
                        for (let y = 0; y < order.order[u].boxes.length; y++) {
                            for (let d = 0; d < order.order[u].boxes[y].fields.length; d++) {
                                if (order.order[u].boxes[y].fields[d].table === 'entity' && order.order[u].boxes[y].fields[d].idFieldTable === 'email') {
                                    email = order.order[u].boxes[y].fields[d].value;
                                }
                            }
                        }
                    }
                }

                for (let r = 0; r < arrayRequerimiento.length; r++) {
                    let idDocFlag = arrayRequerimiento[r].requirement.split('_')[0];
                    console.log('idDocFlag-> ' + idDocFlag)
                    for (let u = 0; u < order.order.length; u++) {
                        console.log('order.order[u].id-> ' + order.order[u].id)

                        if (Number(idDocFlag) === Number(order.order[u].id)) {
                            console.log('INGRESA**')
                            for (let y = 0; y < order.order[u].boxes.length; y++) {
                                for (let d = 0; d < order.order[u].boxes[y].fields.length; d++) {
                                    if (order.order[u].boxes[y].fields[d].idFieldTable === 'status') {
                                        order.order[u].boxes[y].fields[d].value = order.order[u].boxes[y].fields[d].defaultValue;
                                    }
                                }
                            }
                            let fields = [];
                            for (let p = 0; p < arrayRequerimiento[r].description.length; p++) {
                                fields.push({
                                    id: p + 10000,
                                    type: 'Typography',
                                    defaultValue: arrayRequerimiento[r].description[p],
                                    print: false,
                                    columnBreak: true
                                })
                            }
                            let existeRevision = false;
                            for (let h = 0; h < order.order[u].boxes.length; h++) {
                                if (Number(order.order[u].boxes[h].order) === 550) {
                                    existeRevision = true;
                                    order.order[u].boxes[h] = {
                                        order: 550,
                                        fields
                                    }
                                }
                            }
                            if (existeRevision === false) {
                                order.order[u].boxes.push({
                                    order: 550,
                                    fields
                                })
                            }
                        }
                    }
                }
                console.log('order SAVE-> ' + JSON.stringify(order))
                serviceOrders.save(user.client, user.data.instance, id, order).then(() => {

                    setRevision(false);
                    console.log('email-> ' + email)
                    let mail = {
                        recipient: email,
                        msgBody: body,
                        subject: `Revisar Solicitud: ${order.id}`
                    }
                    emailService.sendEmail(mail).then((response) => {
                        navigate(`/listrequirements`);
                        window.location.reload();
                    }).catch((error) => {
                        navigate(`/listrequirements`);
                        window.location.reload();
                        console.log(error);
                    });


                }).catch((error) => {
                    console.log(error);
                });
            } else {
                setError('Ingrese el mensaje a enviar por email')
            }

        }
    }


    const searchOptions = (itemField, nameGroup, entityDocId, dataSource, id) => {

        if (nameGroup)
            nameGroup = nameGroup.split('_')[2];

        let idField;
        let idFieldT;
        if (dataSource !== null) {
            data.forEach((itemData) => {
                if (itemData.id === id) {
                    itemData.boxes.forEach((itemBoxes) => {
                        itemBoxes.fields.forEach((itemFields) => {
                            if (itemFields.group !== null) {
                                itemFields.group.forEach((itemGroup) => {
                                    itemGroup.fields.forEach((itemGroupFields) => {


                                        if (Number(itemGroupFields.id) === Number(dataSource)) {

                                            idField = `${itemData.entityDocId}_${itemData.id}_${itemGroupFields.id}`
                                            /*if (!itemGroupFields.idFlag) {
                                                let entityDocFlag = entityDocId;
                                                if (entityDocId.length > 1) {
                                                    entityDocFlag = `${entityDocId[0]}_${entityDocId[1]}`
                                                }
                                                idField = entityDocFlag + itemGroupFields.id;
                                                
                                            } else {
                                                let entityDocFlag = entityDocId;
                                                if (entityDocId.length > 1) {
                                                    entityDocFlag = `${entityDocId[0]}_${entityDocId[1]}`
                                                }
                                                idField = entityDocFlag + itemGroupFields.id + '_' + itemGroupFields.idFlag
                                            }*/
                                            idFieldT = itemGroupFields.idFieldTable;
                                        }
                                    })
                                })
                            } else {

                                if (Number(itemFields.id) === Number(dataSource)) {

                                    /*if (!itemFields.idFlag) {
                                        let entityDocFlag = entityDocId;
                                        if (entityDocId.length > 1) {
                                            entityDocFlag = `${entityDocId[0]}_${entityDocId[1]}`
                                        }
                                        idField = entityDocFlag + itemFields.id;
                                    } else {
                                        let entityDocFlag = entityDocId;
                                        if (entityDocId.length > 1) {
                                            entityDocFlag = `${entityDocId[0]}_${entityDocId[1]}`
                                        }
                                        idField = entityDocFlag + itemFields.id + '_' + itemFields.idFlag
                                    }*/
                                    idField = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`

                                    idFieldT = itemFields.idFieldTable;
                                }
                            }
                        })
                    })
                }
            })
        }
        let options = [];
        info.forEach((itemInfo) => {
            if (itemField.sourceSelectDoc !== null) {
                itemField.sourceSelectDoc.forEach((itemSourceSelectDoc) => {

                    if (itemInfo.source === itemField.sourceSelect && !nameGroup && itemInfo.doc === itemSourceSelectDoc) {
                        if (dataSource === null || dataSource === undefined)
                            options.push({
                                id: itemInfo.id,
                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                            })
                        else {
                            if (field[idField] || field[idField] === 0) {
                                if (typeof field[idField] === 'object') {
                                    if (Number(field[idField].id) === Number(itemInfo[idFieldT])) {
                                        options.push({
                                            id: itemInfo.id,
                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                        })
                                    }
                                } else {
                                    if (field[idField].toString() === itemInfo[idFieldT].toString()) {
                                        options.push({
                                            id: itemInfo.id,
                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                        })
                                    }
                                }
                            }
                        }

                    } else {
                        if (itemInfo.source === itemField.sourceSelect && nameGroup === itemInfo.group && itemInfo.doc === itemSourceSelectDoc) {
                            if (dataSource === null || dataSource === undefined) {
                                options.push({
                                    id: itemInfo.id,
                                    label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                })
                            }
                            else {
                                if (field[idField] || field[idField] === 0) {
                                    if (typeof field[idField] === 'object') {
                                        if (Number(field[idField].id) === Number(itemInfo[idFieldT])) {
                                            options.push({
                                                id: itemInfo.id,
                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                            })
                                        }
                                    } else {
                                        if (field[idField].toString() === itemInfo[idFieldT].toString()) {
                                            options.push({
                                                id: itemInfo.id,
                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                            })
                                        }
                                    }
                                }
                            }
                        } else {
                            if (itemInfo.source === itemField.sourceSelect && nameGroup && !itemInfo.group && itemInfo.doc === itemSourceSelectDoc) {
                                if (dataSource === null || dataSource === undefined) {
                                    options.push({
                                        id: itemInfo.id,
                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                    })
                                }
                                else {
                                    if (field[idField] || field[idField] === 0) {
                                        if (typeof field[idField] === 'object') {
                                            if (Number(field[idField].id) === Number(itemInfo[idFieldT])) {
                                                options.push({
                                                    id: itemInfo.id,
                                                    label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                })
                                            }
                                        } else {
                                            if (field[idField].toString() === itemInfo[idFieldT].toString()) {
                                                options.push({
                                                    id: itemInfo.id,
                                                    label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                })
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                })

            } else {

                if (itemInfo.source === itemField.sourceSelect && !nameGroup) {
                    if (dataSource === null || dataSource === undefined) {
                        options.push({
                            id: itemInfo.id,
                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                        })
                    }
                    else {
                        if (field[idField] || field[idField] === 0) {
                            if (typeof field[idField] === 'object') {
                                if (Number(field[idField].id) === Number(itemInfo[idFieldT])) {
                                    options.push({
                                        id: itemInfo.id,
                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                    })
                                }
                            } else {
                                if (field[idField].toString() === itemInfo[idFieldT].toString()) {
                                    options.push({
                                        id: itemInfo.id,
                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                    })
                                }
                            }
                        }
                    }

                } else {
                    if (itemInfo.source === itemField.sourceSelect && nameGroup === itemInfo.group) {
                        if (dataSource === null || dataSource === undefined) {

                            options.push({
                                id: itemInfo.id,
                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                            })
                        }
                        else {
                            if (field[idField] || field[idField] === 0) {
                                if (typeof field[idField] === 'object') {
                                    if (Number(field[idField].id) === Number(itemInfo[idFieldT])) {
                                        options.push({
                                            id: itemInfo.id,
                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                        })
                                    }
                                } else {
                                    if (field[idField].toString() === itemInfo[idFieldT].toString()) {
                                        options.push({
                                            id: itemInfo.id,
                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                        })
                                    }
                                }
                            }
                        }
                    } else {
                        if (itemInfo.source === itemField.sourceSelect && nameGroup && !itemInfo.group) {
                            if (dataSource === null || dataSource === undefined) {
                                options.push({
                                    id: itemInfo.id,
                                    label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                })
                            }
                            else {
                                if (field[idField] || field[idField] === 0) {
                                    if (typeof field[idField] === 'object') {
                                        if (Number(field[idField].id) === Number(itemInfo[idFieldT])) {
                                            options.push({
                                                id: itemInfo.id,
                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                            })
                                        }
                                    } else {
                                        if (field[idField].toString() === itemInfo[idFieldT].toString()) {
                                            options.push({
                                                id: itemInfo.id,
                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                            })
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        })
        return options;
    }

    const handleFieldChangeRender = (e, newValue, id) => {
        let changeValue;
        if (e !== null) {
            changeValue = e.target.value;
            if (e.target.type === 'checkbox') {
                changeValue = e.target.checked
            }

            if (e.target.type === 'file') {
                changeValue = e.target.files[0]
            }
        }
        if (newValue) {
            changeValue = newValue;
        }
        setField(prevState => ({
            ...prevState,
            [id]: changeValue,
        }), []);


    };

    const renderFields = (itemField, indexField, itemDoc, arrayDoc, itemBoxs, nameGroup, indexGroup, viewFieldFlag, subGroup, nameSubGroup, indexSubGroup) => {

        if (itemField.view !== 'hidden') {
            let view = true;
            if (itemField.where !== null && itemField.where !== undefined) {
                view = whereFunctions.whereFunction(itemField, field, itemDoc);
            }

            if (view === true) {

                let idField = `${itemDoc.entityDocId}_${itemDoc.id}_${itemField.id}`;
                if (itemField.id.split("_").length > 1) {
                    idField = itemField.id;
                }

                if (viewFieldFlag === false) {
                    if (subGroup === true) {
                        arrayDoc.push(<LabelIcon style={{ marginLeft: '25px' }} color="primary" />);
                    } else {
                        arrayDoc.push(<LabelIcon color="primary" />);
                    }
                }

                let nameField = itemField.name;
                if (itemField.mandatory)
                    nameField = `${nameField} *`

                switch (itemField.type) {
                    case 'Percentage':
                        arrayDoc.push(
                            <div idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid item>
                                        <PercentageComponente
                                            maxLength={itemField.maxLenght}
                                            disabled={true}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(event) => handleFieldChangeRender(event, null, idField)}
                                            itemFunction={itemField.function}
                                            user={user}
                                            instance={user.data.instance}
                                            help={itemField.help}
                                            error={error[idField]}
                                            entityDocId={itemDoc.entityDocId}
                                            mode={false}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'TextField':
                        arrayDoc.push(
                            <div idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid item>
                                        <TextFieldComponent
                                            maxLength={itemField.maxLenght}
                                            disabled={true}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(event) => handleFieldChangeRender(event, null, idField)}
                                            itemFunction={itemField.function}
                                            user={user}
                                            instance={user.data.instance}
                                            help={itemField.help}
                                            error={error[idField]}
                                            entityDocId={itemDoc.entityDocId}
                                            mode={false}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}

                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Select':

                        let options = searchOptions(itemField, nameGroup, itemDoc.entityDocId, itemField.dataSource, itemDoc.id);


                        if (idField === '11_11_18' || idField === '4_4_13' || idField === '12_12_18' || idField === '1_413_18' || (itemField.name === 'Apoderado' && itemField.idFieldTable === null)) {

                            for (let r = 0; r < entity.length; r++) {
                                let ph = false;
                                let entityProp;
                                let idEntity = entity[r].idEntity;
                                let fullName;
                                for (let b = 0; b < entity[r].boxes.length; b++) {

                                    for (let a = 0; a < entity[r].boxes[b].fields.length; a++) {
                                        if (entity[r].boxes[b].fields[a].idFieldTable === 'entityTypeId') {
                                            if (entity[r].boxes[b].fields[a].value) {
                                                if (Number(entity[r].boxes[b].fields[a].value.id) === 1) {
                                                    ph = true;
                                                }
                                            }
                                        }
                                        if (entity[r].boxes[b].fields[a].idFieldTable === 'entityPropId') {
                                            if (entity[r].boxes[b].fields[a].value) {
                                                if (Number(entity[r].boxes[b].fields[a].value.id) === 1 || Number(entity[r].boxes[b].fields[a].value.id) === 2 || Number(entity[r].boxes[b].fields[a].value.id) === 3) {
                                                    entityProp = true;
                                                }
                                            }
                                        }
                                        if (entity[r].boxes[b].fields[a].idFieldTable === 'fullName') {
                                            fullName = entity[r].boxes[b].fields[a].value;
                                        }
                                    }

                                }
                                if (ph === true && entityProp === true) {

                                    options.push({
                                        id: idEntity,
                                        label: fullName
                                    })
                                }
                            }
                        }
                       
                        arrayDoc.push(
                            <div idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid xs={3} item>
                                        <SelectComponent
                                            disabled={true}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(event, newValue) => handleFieldChangeRender(event, newValue, idField)}
                                            help={itemField.help}
                                            options={options}
                                            mode={false}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'File':
                        arrayDoc.push(
                            <div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                                <Grid container xs={12} item>
                                    <Grid item>
                                        <FileComponent
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                            help={itemField.help}
                                            id={idField}
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                        );
                        break;
                    case 'Typography':
                        let paragraphType = 'body1';
                        let fontSize = '0.8rem';
                        if (itemField.cssClass === 'titleStyle4') {
                            paragraphType = 'h4';
                            fontSize = null;
                            fontSize = '1.2rem';
                        }

                        arrayDoc.push(
                            <div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid item>

                                        <TypographyComponent
                                            paragraphType={paragraphType}
                                            text={itemField.defaultValue}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                            style={{ fontSize: fontSize }}
                                        />

                                    </Grid>
                                </Grid>
                            </div>
                        );

                        break;
                    case 'Json':
                        arrayDoc.push(
                            //<div style={{ display: 'inline-block' }}>
                            <div idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid item>
                                        <JsonComponent
                                            maxLength={itemField.maxLenght}
                                            disabled={true}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            itemFunction={itemField.function}
                                            user={user}
                                            instance={user.data.instance}
                                            help={itemField.help}
                                            //mandatory={itemField.mandatory}
                                            error={error[idField]}
                                            entityDocId={itemDoc.entityDocId}
                                            mode={false}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Number':
                        arrayDoc.push(
                            //<div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                            <div idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid item>
                                        <NumberComponent
                                            maxLength={itemField.maxLenght}
                                            disabled={true}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            itemFunction={itemField.function}
                                            help={itemField.help}
                                            mode={false}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                            onChange={(event) => handleFieldChangeRender(event, null, idField)}

                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Currency':
                        arrayDoc.push(
                            //<div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                            <div idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid item>
                                        <CurrencyComponent
                                            maxLength={itemField.maxLenght}
                                            disabled={true}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            itemFunction={itemField.function}
                                            help={itemField.help}
                                            mode={false}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                            onChange={(event) => handleFieldChangeRender(event, null, idField)}

                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Checkbox':

                        let valueCheckbox = field[idField];
                        if (valueCheckbox === '0')
                            valueCheckbox = false;

                        arrayDoc.push(
                            // <div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                            <div className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid xs={12} item>
                                        <CheckBoxComponent
                                            disabled={true}
                                            id={idField}
                                            name={nameField}
                                            value={valueCheckbox}
                                            help={itemField.help}
                                            mode={false}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Switch':
                        let valueSwitch = field[idField];
                        if (valueSwitch === '0')
                            valueSwitch = false;
                        arrayDoc.push(
                            //<div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                            <div className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid xs={8} item>
                                        <SwitchComponent
                                            disabled={true}
                                            id={idField}
                                            name={nameField}
                                            value={valueSwitch}
                                            help={itemField.help}
                                            mode={false}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Radio':
                        arrayDoc.push(
                            //<div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                            <div className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid xs={12} item>
                                        <RadioComponent
                                            name={nameField}
                                            value={field[idField]}
                                            help={itemField.help}
                                            options={itemField.radioGroup}
                                            mode={false}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Date':
                        arrayDoc.push(
                            //<div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                            <div idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid item>
                                        <DateComponent
                                            disabled={true}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            help={itemField.help}
                                            mode={false}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    default:
                        break;
                }

                if (indexField < itemBoxs.fields.length - 1 && itemField.columnBreak) {
                    arrayDoc.push(<br />);
                }
                return true;
            }
        }
    }

    const searchOrder = (order, info) => {

        if (order) {
            var entityFlag = addEntity(order.order);
            for (let u = 0; u < order.order.length; u++) {

                for (let y = 0; y < order.order[u].boxes.length; y++) {

                    for (let d = 0; d < order.order[u].boxes[y].fields.length; d++) {

                        if (order.order[u].boxes[y].fields[d].group === null) {

                            let idField = order.order[u].boxes[y].fields[d].id;
                            if (order.order[u].boxes[y].fields[d].id.split('_').length === 1)
                                idField = `${order.order[u].entityDocId}_${order.order[u].id}_${order.order[u].boxes[y].fields[d].id}`

                            switch (order.order[u].boxes[y].fields[d].type) {
                                case 'Select':

                                    if (order.order[u].boxes[y].fields[d].defaultValue === 'entityIx()') {

                                        for (let q = 0; q < order.order[u].boxes[y].fields.length; q++) {
                                            if (order.order[u].boxes[y].fields[q].idFieldTable === 'fullName') {
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idField]: {
                                                        id: 1,
                                                        label: order.order[u].boxes[y].fields[q].value
                                                    }
                                                    //[idField]: order.order[u].boxes[y].fields[q].value
                                                }));
                                            }
                                        }
                                    } else {


                                        let existe = false;
                                        info.forEach((itemInfo) => {
                                            if (itemInfo.source === order.order[u].boxes[y].fields[d].sourceSelect) {
                                                if (Number(order.order[u].boxes[y].fields[d].value) === Number(itemInfo.id)) {
                                                    existe = true;
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: {
                                                            id: itemInfo.id,
                                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                        }
                                                    }), []);
                                                }
                                            }
                                        })
                                        if (existe === false) {
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: null
                                            }), []);
                                        }
                                    }
                                    break;
                                case 'Checkbox':
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: false
                                    }));
                                    if (order.order[u].boxes[y].fields[d].value === 'true') {
                                        setField(prevState => ({
                                            ...prevState,
                                            [idField]: true
                                        }));
                                    }
                                    break;
                                case 'Switch':
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: false
                                    }));
                                    if (order.order[u].boxes[y].fields[d].value === 'true') {
                                        setField(prevState => ({
                                            ...prevState,
                                            [idField]: true
                                        }));
                                    }
                                    break;
                                default:
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: order.order[u].boxes[y].fields[d].value
                                    }));
                                    break;
                            }

                        } else {
                            let nameGroup;
                            let arrayGroupObjects = [];
                            for (let n = 0; n < order.order[u].boxes[y].fields[d].group.length; n++) {

                                nameGroup = `${order.order[u].entityDocId}_${order.order[u].id}_${order.order[u].boxes[y].fields[d].group[n].name}`;

                                let objArrayElement = JSON.parse(JSON.stringify(order.order[u].boxes[y].fields[d].group[n]));
                                for (let m = 0; m < objArrayElement.fields.length; m++) {
                                    objArrayElement.fields[m].isGroup = true;
                                }

                                for (let m = 0; m < order.order[u].boxes[y].fields[d].group[n].fields.length; m++) {

                                    if (order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup !== null) {
                                        //SUBGROUP
                                        let arraySubGroupObjects = [];
                                        for (let e = 0; e < order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup.length; e++) {

                                            let objArrayElementSubgroup = JSON.parse(JSON.stringify(order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e]));
                                            for (let m = 0; m < objArrayElementSubgroup.fields.length; m++) {
                                                objArrayElementSubgroup.fields[m].isGroup = true;
                                            }

                                            for (let k = 0; k < order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields.length; k++) {

                                                let idField = order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].id;
                                                if (order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].id.split('_').length === 1)
                                                    idField = `${order.order[u].entityDocId}_${order.order[u].id}_${order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].id}`

                                                if (order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].type) {
                                                    switch (order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].type) {
                                                        case 'Select':
                                                            let existe = false;
                                                            info.forEach((itemInfo) => {
                                                                if (itemInfo.source === order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].sourceSelect) {
                                                                    if (Number(order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].value) === Number(itemInfo.id)) {
                                                                        existe = true;
                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [idField]: {
                                                                                id: itemInfo.id,
                                                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                            }
                                                                        }), []);
                                                                    }
                                                                }
                                                            })
                                                            if (existe === false) {
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [idField]: null
                                                                }), []);
                                                            }
                                                            break;
                                                        case 'Checkbox':
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [idField]: false
                                                            }));
                                                            if (order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].value === 'true') {
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [idField]: true
                                                                }));
                                                            }
                                                            break;
                                                        case 'Switch':
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [idField]: false
                                                            }));
                                                            if (order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].value === 'true') {
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [idField]: true
                                                                }));
                                                            }
                                                            else {
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [idField]: true
                                                                }));
                                                            }
                                                            break;
                                                        default:

                                                            let value = order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].value;
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [idField]: value
                                                            }));

                                                            break;
                                                    }
                                                }
                                            }
                                            if (e !== 0) {
                                                arraySubGroupObjects.push(objArrayElementSubgroup)
                                            }
                                        }
                                        objArrayElement.subGroup = arraySubGroupObjects;
                                    } else {

                                        //let idField = order.order[u].boxes[y].fields[d].group[n].fields[m].id;

                                        let idField = order.order[u].boxes[y].fields[d].group[n].fields[m].id;
                                        if (order.order[u].boxes[y].fields[d].group[n].fields[m].id.split('_').length === 1)
                                            idField = `${order.order[u].entityDocId}_${order.order[u].id}_${order.order[u].boxes[y].fields[d].group[n].fields[m].id}`

                                        switch (order.order[u].boxes[y].fields[d].group[n].fields[m].type) {
                                            case 'Select':

                                                if (order.order[u].boxes[y].fields[d].group[n].fields[m].name === 'Apoderado' && order.order[u].boxes[y].fields[d].group[n].fields[m].idFieldTable === null) {
                                                    console.log('INGREA SETEAR APODERADOS')
                                                    console.log('entity' + JSON.stringify(entityFlag))
                                                    for (let q = 0; q < entityFlag.length; q++) {
                                                        if (Number(entityFlag[q].id) === Number(order.order[u].boxes[y].fields[d].group[n].fields[m].value)) {
                                                            console.log('INGREA SETEAR APODERADOS***********')
                                                            for (let v = 0; v < entityFlag[q].boxes.length; v++) {
                                                                for (let b = 0; b < entityFlag[q].boxes[v].fields.length; b++) {
                                                                    if (entityFlag[q].boxes[v].fields[b].idFieldTable === 'fullName') {
                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [idField]: {
                                                                                id: entityFlag[q].id,
                                                                                label: entityFlag[q].boxes[v].fields[b].value
                                                                            }
                                                                        }));
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                } else {
                                                    let existe = false;
                                                    info.forEach((itemInfo) => {
                                                        if (itemInfo.source === order.order[u].boxes[y].fields[d].group[n].fields[m].sourceSelect) {
                                                            if (Number(order.order[u].boxes[y].fields[d].group[n].fields[m].value) === Number(itemInfo.id)) {
                                                                existe = true;
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [idField]: {
                                                                        id: itemInfo.id,
                                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                    }
                                                                }), []);
                                                            }
                                                        }
                                                    })
                                                    if (existe === false) {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [idField]: null
                                                        }), []);
                                                    }
                                                }
                                                break;
                                            case 'Checkbox':
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idField]: false
                                                }));
                                                if (order.order[u].boxes[y].fields[d].group[n].fields[m].value === 'true') {
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: true
                                                    }));
                                                }
                                                break;
                                            case 'Switch':
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idField]: false
                                                }));

                                                if (order.order[u].boxes[y].fields[d].group[n].fields[m].value === 'true') {
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: true
                                                    }));
                                                }
                                                else {
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: false
                                                    }));
                                                }
                                                break;
                                            default:
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idField]: order.order[u].boxes[y].fields[d].group[n].fields[m].value
                                                }));
                                                break;
                                        }
                                    }
                                }

                                /*if (n !== 0) {
                                    arrayGroupObjects.push(objArrayElement)
                                }
                                if (n === 0 && order.order[u].condominoApoderado === true) {
                                    arrayGroupObjects.push(objArrayElement);
                                }*/
                                arrayGroupObjects.push(objArrayElement);
                            }

                            console.log('arrayGroupObjects-> ' + JSON.stringify(arrayGroupObjects))
                            if (arrayGroupObjects.length > 0) {
                                if (group[nameGroup]) {
                                    setGroup(prevState => ({
                                        ...prevState,
                                        [nameGroup]: [...prevState[nameGroup], ...arrayGroupObjects]
                                    }));
                                }
                                else {
                                    setGroup(prevState => ({
                                        ...prevState,
                                        [nameGroup]: arrayGroupObjects
                                    }));
                                }
                            }
                        }
                    }
                }
            }
        }

    }

    const addEntity = (data) => {
        for (let h = 0; h < data.length; h++) {
            for (let t = 0; t < data[h].boxes.length; t++) {
                for (let key in field) {

                    for (let t = 0; t < data[h].boxes.length; t++) {
                        for (let y = 0; y < data[h].boxes[t].fields.length; y++) {

                            let idField = `${data[h].entityDocId}_${data[h].id}_${data[h].boxes[t].fields[y].id}`
                            if (idField === key) {
                                data[h].boxes[t].fields[y].value = field[key];
                            }
                        }
                    }
                }
            }
        }

        let arrayData = [];
        let ultimoId;
        data.forEach((itemData) => {
            if (Number(itemData.entityDocId) === 2) {
                itemData.idEntity = itemData.id;
                arrayData.push(itemData);
                ultimoId = Number(itemData.id);
            }
        })

        if (group['5_5_Autorizados']) {
            group['5_5_Autorizados'].forEach((item) => {
                let existe = false;

                item.fields.forEach((itemFields) => {

                    let idField = itemFields.id;
                    if (itemFields.id.split('_').length === 1)
                        idField = `5_5_${itemFields.id}`
                    if (itemFields.idFieldTable === 'argTin') {
                        let cuit = field[idField];
                        if (cuit)
                            existe = true;
                    }
                    itemFields.value = field[idField];
                })
                if (existe === true) {
                    ultimoId++;
                    arrayData.push({
                        idEntity: ultimoId,
                        entityDocId: '5',
                        boxes: [item]
                    });
                }

            })
        }
        setEntity(arrayData);
        return arrayData;
    }

    const filteredData = order ? order.order.filter(itemDoc => whereFunctions.whereFunctionHeader(itemDoc, entity)) : null;

    const addElementGroup = (index) => {
        let newObject = { index }
        setGroupRequirements(prevArray => [...prevArray, newObject]);
    }

    const onDeleteElementGroup = (index) => {
        let arrayFlag = [];
        for (let i = 0; i < groupRequirements.length; i++) {
            if (Number(i) !== Number(index)) {
                arrayFlag.push(groupRequirements[i]);
            }
        }

        setGroupRequirements(arrayFlag);
    }

    return (

        <ThemeProvider theme={constantsDesign.CUSTOM_MUI_GENERAL_THEME}>
            <div className="App">
                <CssBaseline />
                <header className="App-header">
                    <Box ref={boxRef} sx={{ width: "100%", flexGrow: 1 }}>
                        <Grid container xs={12} item>
                            <Grid container sx={{ m: 1 }} xs={12} item>
                                <ThemeProvider theme={constantsDesign.CUSTOM_MUI_TEXT_FIELD_THEME}>
                                    <Box sx={{ width: '100%' }}>
                                        <MenuApp />
                                        <br></br>
                                        <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
                                            Requerimiento {id}
                                        </Typography>
                                        <Button variant='outlined' style={{ marginRight: '8px' }} onClick={() => navigate('/listrequirements')}>Volver</Button>
                                        <Button variant='outlined' style={{ marginRight: '8px' }} onClick={() => aprobar()}>Aprobar</Button>
                                        <Button variant='outlined' style={{ marginRight: '8px' }} onClick={() => solicitarRevision()}>Solicitar Revisión</Button>
                                        <Button variant='outlined' onClick={() => rechazar()} >Rechazar</Button>
                                        {load && (
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <CircularProgress size={150} />
                                            </div>
                                        )}

                                        {!load && (<div>

                                            {revision && (
                                                <div>
                                                    <TextField sx={{ width: '100%' }}
                                                        id="email"
                                                        label="Contenido email"
                                                        multiline
                                                        rows={4}
                                                        variant="standard"
                                                    />

                                                    {groupRequirements && (

                                                        groupRequirements.map((item, index) => {
                                                            return (<div>
                                                                <div style={{ display: 'inline-block', margin: '10px 0.2px' }}>
                                                                    <Grid container sx={{ m: 1 }} xs={12} item>
                                                                        <Grid xs={3} item>
                                                                            <SelectComponent
                                                                                id={`requerimiento_${index}`}
                                                                                name='Requerimiento a revisar'
                                                                                options={optionsOrder}
                                                                            />
                                                                        </Grid>
                                                                    </Grid>
                                                                </div>
                                                                <div style={{ display: 'inline-block', margin: '10px 0.2px' }}>
                                                                    <Grid container sx={{ m: 1 }} xs={12} item>
                                                                        <Grid item>
                                                                            <TextFieldComponent
                                                                                id={`descripcion_${index}`}
                                                                                name='Descripción de revisión'
                                                                            />
                                                                        </Grid>
                                                                    </Grid>
                                                                </div>

                                                                {groupRequirements.length > 1 && index > 0 && (
                                                                    <div style={{ display: 'inline-block', margin: '10px 0.2px' }}>
                                                                        <Grid container sx={{ m: 1 }} xs={12} item>
                                                                            <Grid item>
                                                                                <Button onClick={() => { onDeleteElementGroup(index) }}>
                                                                                    <DeleteIcon style={{ fontSize: '20px' }} />
                                                                                </Button>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </div>
                                                                )}


                                                                {index === groupRequirements.length - 1 && (
                                                                    <div style={{ display: 'inline-block', margin: '10px 0.2px' }}>
                                                                        <Grid container sx={{ m: 1 }} xs={12} item>
                                                                            <Grid item>
                                                                                <Button onClick={() => { addElementGroup(index + 1) }}>
                                                                                    <AddCircleIcon style={{ fontSize: '20px' }} />
                                                                                </Button>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </div>
                                                                )}
                                                            </div>)
                                                        })
                                                    )}

                                                    {error && (
                                                        <h6 style={{ color: 'red' }}>{error}</h6>
                                                    )}
                                                    {!error && (
                                                        <div />
                                                    )}
                                                    <Button variant='outlined' style={{ marginRight: '8px' }} onClick={() => enviarRevisón()}>Enviar E-mail</Button>
                                                </div>

                                            )}

                                            {!revision && (
                                                <TextField
                                                    id="nrocuenta"
                                                    label="N° Cuenta"
                                                    variant="standard"
                                                />
                                            )}
                                            {error && (
                                                <h6 style={{ color: 'red' }}>{error}</h6>
                                            )}

                                            <div id="pdf-content">
                                                {filteredData.map((itemDoc) => {

                                                    let arrayDoc = [];
                                                    if (itemDoc.onboardingPrint === true) {

                                                        itemDoc.header.forEach((itemHeader) => {
                                                            arrayDoc.push(<img alt='' src={logoTest} />)
                                                        })
                                                        itemDoc.boxes.forEach((itemBoxs, indexBoxs) => {

                                                            let arrayItemBoxs = [];
                                                            let arrayItemBoxsFlag = [];
                                                            let title = false;

                                                            itemBoxs.fields.forEach((itemField, indexField) => {
                                                                if (itemField.group !== null && itemField.group !== undefined) {
                                                                    itemField.group.forEach((itemGroup, indexGroup) => {
                                                                        if (indexGroup === 0) {
                                                                            let nameGroup = `${itemDoc.entityDocId}_${itemDoc.id}_${itemGroup.name}`;
                                                                            console.log('nameGroup-> ' + nameGroup)
                                                                            if (group[nameGroup]) {
                                                                                console.log('group[nameGroup]-> ' + JSON.stringify(group[nameGroup]))
                                                                                group[nameGroup].forEach((item1, index) => {

                                                                                    if (Number(item1.id) === Number(itemDoc.id)) {

                                                                                        arrayDoc.push(<div />);
                                                                                        let arrayItemGroup = [];
                                                                                        if (item1.fields !== null) {
                                                                                            let viewFieldFlag = false;
                                                                                            item1.fields.forEach((itemFields, indexFields) => {
                                                                                                let viewFlag = false;
                                                                                                if (itemFields.type !== 'File' && itemFields.print === true) {
                                                                                                    viewFlag = renderFields(itemFields, indexFields, itemDoc, arrayItemGroup, itemBoxs, nameGroup, index, viewFieldFlag, false, null, null);
                                                                                                }
                                                                                                if (viewFlag === true) {
                                                                                                    viewFieldFlag = true;
                                                                                                }

                                                                                                //SUBGROUP
                                                                                                if (itemFields.subGroup !== null && itemFields.subGroup !== undefined) {
                                                                                                    itemFields.subGroup.forEach((item2, indexItemSubGroupFields) => {
                                                                                                        arrayDoc.push(<div />);
                                                                                                        let arrayItemSubGroup = [];
                                                                                                        item2.fields.forEach((itemFields, indexFields) => {
                                                                                                            let nameSubGroup = `${itemDoc.id}_${item2.id}_${item2.name}`;
                                                                                                            let viewFlag = false;
                                                                                                            if (itemFields.type !== 'File' && itemFields.print === true) {
                                                                                                                viewFlag = renderFields(itemFields, indexFields, itemDoc, arrayItemSubGroup, itemBoxs, nameGroup, index, itemDoc.entityDocId, true, nameSubGroup, indexItemSubGroupFields);
                                                                                                            }

                                                                                                            if (viewFlag === true) {
                                                                                                                viewFieldFlag = true;
                                                                                                            }
                                                                                                        })
                                                                                                        if (arrayItemSubGroup.length > 0) {
                                                                                                            arrayItemGroup.push(<Box border={1} borderColor="grey.400" borderRadius="4px" p={2} padding={1}>
                                                                                                                {arrayItemSubGroup}
                                                                                                            </Box>);
                                                                                                            arrayItemGroup.push(<div style={{ height: '4px' }} />);
                                                                                                        }


                                                                                                    })
                                                                                                }
                                                                                            })



                                                                                        }
                                                                                        if (arrayItemGroup.length > 1) {
                                                                                            arrayItemBoxsFlag.push(<Box border={1} borderColor="grey.400" borderRadius="4px" p={2} padding={1}>

                                                                                                {arrayItemGroup}

                                                                                            </Box>);
                                                                                            arrayItemBoxsFlag.push(<div style={{ height: '4px' }} />);
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }
                                                                        }
                                                                    })

                                                                } else {
                                                                    if (itemField.type !== 'File' && itemField.print === true) {
                                                                        let response = renderFields(itemField, indexField, itemDoc, arrayItemBoxsFlag, itemBoxs, null, null, true, null, null, null);
                                                                        if (response === true)
                                                                            title = true;
                                                                    }
                                                                }
                                                            })

                                                            if (arrayItemBoxsFlag.length > 0) {

                                                                if (itemBoxs.box && title) {
                                                                    arrayItemBoxs.push(<Grid container sx={{ m: 1 }} xs={12} item>
                                                                        <Grid item><TypographyComponent
                                                                            paragraphType='body1'
                                                                            text={itemBoxs.box}
                                                                        /></Grid>
                                                                    </Grid>)
                                                                }
                                                                for (let d = 0; d < arrayItemBoxsFlag.length; d++) {
                                                                    arrayItemBoxs.push(arrayItemBoxsFlag[d]);
                                                                }
                                                            }

                                                            if (arrayItemBoxs.length >= 1) {
                                                                arrayDoc.push(<Box border={1} borderColor="grey.400" borderRadius="4px" p={2} padding={1}>
                                                                    {arrayItemBoxs}
                                                                </Box>);
                                                                if (itemDoc.boxes.length - 1 !== indexBoxs)
                                                                    arrayDoc.push(<div style={{ height: '8px' }} />);
                                                            }
                                                        })

                                                        arrayDoc.push(<div className="page-break"></div>)

                                                        return <div id={'pdf_content_' + itemDoc.id + '_' + itemDoc.entityDocId}>{arrayDoc}</div>;
                                                    }
                                                    return null;
                                                })}
                                            </div>
                                        </div>
                                        )}


                                    </Box>
                                </ThemeProvider>
                            </Grid>
                        </Grid>
                    </Box>
                </header>
            </div>
        </ThemeProvider>
    );

}

export default SystemPages;